// import React, { useEffect, useState } from "react";
// import {
//   LineChart, Line, XAxis, YAxis, Tooltip, CartesianGrid, ResponsiveContainer, AreaChart, Area, BarChart,
//   Bar
// } from "recharts";
// import api from '../api';
// import TestChart from "./TestChart";

// const Dashboard = () => {
//   const [totalEmployees, setTotalEmployees] = useState(0);
//   const [netPayThisMonth, setNetPayThisMonth] = useState(0);
//   const [netPayYTD, setNetPayYTD] = useState(0);
//   const [chartData, setChartData] = useState([]);
//   const [yearlyData, setYearlyData] = useState([]);


//   useEffect(() => {
//     loadDashboard();
//   }, []);


// async function loadDashboard() {
//   const empRes = await api.get('/dashboard/total-employees');
//   setTotalEmployees(empRes.data.total || 0);

//   const month = new Date().toISOString().slice(5, 7);

//   const netRes = await api.get(`/dashboard/netpay/${month}`);
//   setNetPayThisMonth(netRes.data.total || 0);

//   const ytdRes = await api.get('/dashboard/netpay-ytd');
//   setNetPayYTD(ytdRes.data.total || 0);

//   const chartRes = await api.get("/dashboard/netpay-current-year");
//   const rows = chartRes.data || [];

//   const monthNames = ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];

//   const mapped = rows.map(row => ({
//     name: monthNames[row.month - 1],  // 1 → Jan
//     netpay: Number(row.netpay || 0),
//     }));
//   setChartData(mapped);

//   const yearlyRes = await api.get("/dashboard/netpay-yearly");

//   const mappedYear = yearlyRes.data.map(row => ({
//     year: row.year.toString(),
//     netpay: Number(row.netpay || 0),
//   }));

//   setYearlyData(mappedYear);

// }

//   return (
//     <div className="dashboard-container">
//       <h2>Payroll Dashboard</h2>

//       {/* KPIs */}
//       <div className="kpi-row">
//         <div className="kpi-card">
//           <h3>👥 Total Employees</h3>
//           <p>{totalEmployees}</p>
//         </div>

//         <div className="kpi-card">
//           <h3>💸 Net Pay (This Month)</h3>
//           <p>₹{netPayThisMonth.toLocaleString()}</p>
//         </div>

//         <div className="kpi-card">
//           <h3>📅 Year-to-Date Net Pay</h3>
//           <p>₹{netPayYTD.toLocaleString()}</p>
//         </div>
//       </div>

//       {/* Chart */}
//       <div className="chart-box">
//         <h3>Net Pay Trend – Current Year</h3>

//         <ResponsiveContainer width="100%" height={280}>
//           <AreaChart data={chartData}>
//             <defs>
//               <linearGradient id="netColor" x1="0" y1="0" x2="0" y2="1">
//                 <stop offset="0%" stopColor="#4f46e5" stopOpacity={0.5}/>
//                 <stop offset="100%" stopColor="#4f46e5" stopOpacity={0}/>
//               </linearGradient>
//             </defs>

//             <CartesianGrid stroke="#e5e7eb" strokeDasharray="4 4" />
//             <XAxis dataKey="name" tick={{ fontSize: 12 }} />
//             <YAxis tick={{ fontSize: 12 }} />
//             <Tooltip />

//             <Area
//               type="monotone"
//               dataKey="netpay"
//               stroke="#4f46e5"
//               strokeWidth={3}
//               fill="url(#netColor)"
//             />
//           </AreaChart>
//         </ResponsiveContainer>
//       </div>

//       <div className="chart-box" style={{ marginTop: 40 }}>
//   <h3>Yearly Net Pay Trend (Past 5 Years)</h3>

//   <ResponsiveContainer width="100%" height={300}>
//     <BarChart data={yearlyData} barSize={38}>
//       <defs>
//         <linearGradient id="barColor" x1="0" y1="0" x2="0" y2="1">
//           <stop offset="0%" stopColor="#4f46e5" stopOpacity={1} />
//           <stop offset="100%" stopColor="#818cf8" stopOpacity={0.3} />
//         </linearGradient>
//       </defs>

//       <CartesianGrid strokeDasharray="3 3" stroke="#e5e7eb" />

//       <XAxis 
//         dataKey="year"
//         tick={{ fontSize: 13 }}
//       />

//       <YAxis tick={{ fontSize: 13 }} />

//       <Tooltip 
//         wrapperStyle={{ borderRadius: 10 }}
//         contentStyle={{ backgroundColor: "white", borderRadius: 8 }}
//       />

//       <Bar 
//         dataKey="netpay"
//         fill="url(#barColor)"
//         radius={[10, 10, 0, 0]}   // rounded top corners
//       />
//     </BarChart>
//   </ResponsiveContainer>
// </div>

//     </div>
//   );
// }

// export default Dashboard;















import React, { useEffect, useState } from "react";
import {
  AreaChart,
  Area,
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  CartesianGrid,
  ResponsiveContainer
} from "recharts";
import api from "../api";

const Dashboard = () => {
  const [totalEmployees, setTotalEmployees] = useState(0);
  const [netPayThisMonth, setNetPayThisMonth] = useState(0);
  const [netPayYTD, setNetPayYTD] = useState(0);
  const [chartData, setChartData] = useState([]);
  const [yearlyData, setYearlyData] = useState([]);
  const [upcomingBirthdays, setUpcomingBirthdays] = useState([]);

  useEffect(() => {
    loadDashboard();
  }, []);

  async function loadDashboard() {
    const empRes = await api.get("/dashboard/total-employees");
    setTotalEmployees(empRes.data.total || 0);

    const month = new Date().toISOString().slice(5, 7); // "11"
    const netRes = await api.get(`/dashboard/netpay/${month}`);
    setNetPayThisMonth(netRes.data.total || 0);

    const ytdRes = await api.get("/dashboard/netpay-ytd");
    setNetPayYTD(ytdRes.data.total || 0);

    const chartRes = await api.get("/dashboard/netpay-current-year");
    const rows = chartRes.data || [];
    const monthNames = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec"
    ];
    const mapped = rows.map((row) => ({
      name: monthNames[row.month - 1],
      netpay: Number(row.netpay || 0)
    }));
    setChartData(mapped);

    const yearlyRes = await api.get("/dashboard/netpay-yearly");
    const mappedYear = yearlyRes.data.map((row) => ({
      year: row.year.toString(),
      netpay: Number(row.netpay || 0)
    }));
    setYearlyData(mappedYear);

    // Upcoming birthdays for the current month (today onward)
    try {
      const empList = await api.get("/employees");
      const today = new Date();
      const m = today.getMonth();
      const d = today.getDate();
      const bdays = (empList.data || [])
        .filter((e) => e.date_of_birth)
        .map((e) => ({ ...e, dob: new Date(e.date_of_birth) }))
        .filter((e) => e.dob.getMonth() === m && e.dob.getDate() >= d)
        .sort((a, b) => a.dob.getDate() - b.dob.getDate())
        .slice(0, 10) // top 10 for brevity
        .map((e) => ({
          id: e.id,
          emp_code: e.emp_code,
          name: `${e.first_name || ""} ${e.last_name || ""}`.trim(),
          day: e.dob.getDate(),
        }));
      setUpcomingBirthdays(bdays);
    } catch (err) {
      console.error("Error loading upcoming birthdays", err);
      setUpcomingBirthdays([]);
    }
  }

  const now = new Date();
  const currentMonthLabel = now.toLocaleString("en-IN", {
    month: "long",
    year: "numeric"
  });

  return (
    <div>
            <div className="dashboard-header">
        <div>
          <h1 className="dashboard-title">Payroll Dashboard</h1>
          <p className="dashboard-subtitle">
            Quick snapshot of payouts, trends, and employee coverage.
          </p>
        </div>
        <div className="dashboard-chip">
          <span>As of</span>
          <strong>{currentMonthLabel}</strong>
        </div>
      </div>
    
    <div className="dashboard-shell">

      {/* KPI cards */}
      <div className="kpi-row">
        <div className="kpi-card">
          <div className="kpi-icon kpi-icon-blue">👥</div>
          <div className="kpi-content">
            <span className="kpi-label">Total Employees</span>
            <span className="kpi-value">{totalEmployees}</span>
          </div>
        </div>

        <div className="kpi-card">
          <div className="kpi-icon kpi-icon-green">💸</div>
          <div className="kpi-content">
            <span className="kpi-label">Net Pay (This Month)</span>
            <span className="kpi-value">
              ₹{netPayThisMonth.toLocaleString("en-IN")}
            </span>
          </div>
        </div>

        <div className="kpi-card">
          <div className="kpi-icon kpi-icon-purple">📅</div>
          <div className="kpi-content">
            <span className="kpi-label">Year-to-Date Net Pay</span>
            <span className="kpi-value">
              ₹{netPayYTD.toLocaleString("en-IN")}
            </span>
          </div>
        </div>
      </div>

      {/* Upcoming birthdays */}
      <div className="chart-card" style={{ marginBottom: 16 }}>
        <div className="chart-header">
          <h3>Upcoming Birthdays (This Month)</h3>
          <span className="chart-caption">
            From today through month end
          </span>
        </div>
        {upcomingBirthdays.length === 0 ? (
          <p className="text-muted" style={{ margin: "8px 0 0" }}>
            No remaining birthdays this month.
          </p>
        ) : (
          <div style={{ overflowX: "auto", marginTop: 8 }}>
            <table className="table">
              <thead>
                <tr>
                  <th>Day</th>
                  <th>Name</th>
                  <th>Emp Code</th>
                </tr>
              </thead>
              <tbody>
                {upcomingBirthdays.map((b) => (
                  <tr key={b.id}>
                    <td>{String(b.day).padStart(2, "0")}</td>
                    <td>{b.name}</td>
                    <td>{b.emp_code}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>

      {/* Charts grid */}
      <div className="charts-grid">
        {/* Monthly chart */}
        <div className="chart-card">
          <div className="chart-header">
            <h3>Net Pay Trend – Current Year</h3>
            <span className="chart-caption">
              Shows total net pay credited month by month.
            </span>
          </div>

          <ResponsiveContainer width="100%" height={260}>
            <AreaChart data={chartData}>
              <defs>
                <linearGradient id="netColor" x1="0" y1="0" x2="0" y2="1">
                  <stop
                    offset="0%"
                    stopColor="#4f46e5"
                    stopOpacity={0.55}
                  />
                  <stop
                    offset="100%"
                    stopColor="#4f46e5"
                    stopOpacity={0}
                  />
                </linearGradient>
              </defs>

              <CartesianGrid stroke="#e5e7eb" strokeDasharray="4 4" />
              <XAxis dataKey="name" tick={{ fontSize: 12 }} />
              <YAxis tick={{ fontSize: 12 }} />
              <Tooltip />
              <Area
                type="monotone"
                dataKey="netpay"
                stroke="#4f46e5"
                strokeWidth={3}
                fill="url(#netColor)"
              />
            </AreaChart>
          </ResponsiveContainer>
        </div>

        {/* Yearly bar chart */}
        <div className="chart-card">
          <div className="chart-header">
            <h3>Yearly Net Pay Trend (Past 5 Years)</h3>
            <span className="chart-caption">
              Sum of net pay for each financial year.
            </span>
          </div>

          <ResponsiveContainer width="100%" height={260}>
            <BarChart data={yearlyData} barSize={32}>
              <defs>
                <linearGradient id="barColor" x1="0" y1="0" x2="0" y2="1">
                  <stop
                    offset="0%"
                    stopColor="#6366f1"
                    stopOpacity={0.95}
                  />
                  <stop
                    offset="100%"
                    stopColor="#a5b4fc"
                    stopOpacity={0.3}
                  />
                </linearGradient>
              </defs>

              <CartesianGrid strokeDasharray="3 3" stroke="#e5e7eb" />
              <XAxis dataKey="year" tick={{ fontSize: 12 }} />
              <YAxis tick={{ fontSize: 12 }} />
              <Tooltip
                wrapperStyle={{ borderRadius: 10 }}
                contentStyle={{ backgroundColor: "white", borderRadius: 8 }}
              />
              <Bar
                dataKey="netpay"
                fill="url(#barColor)"
                radius={[10, 10, 0, 0]}
              />
            </BarChart>
          </ResponsiveContainer>
        </div>
      </div>
    </div>
    </div>
  );
};

export default Dashboard;
